import { Button, Grid, InputLabel, styled, Theme, makeStyles, createStyles } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
export const MainCont = styled('div')({
  display: 'flex',
  flexDirection: 'column',

  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    background: '#0e1319',
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: '#c2ccd8',

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },
});

export const Heading = styled(Typography)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  // borderBottom: '1px solid #2d343e',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0 20px',
  display: 'flex',
  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const TwoColumnHeading = styled(Typography)({
  position: 'relative',
  borderBottom: '1px solid #2d343e',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0 20px',
  display: 'flex',
  justifyContent: 'space-between',

  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },

  '& a': {
    fontSize: 14,
    cursor: 'pointer',
  },
});

export const ThreeColumn = styled('div')<Theme, { isModal: number }>(({ theme, isModal }) => ({
  display: 'grid',
  gap: 20,
  gridTemplateColumns: isModal ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: isModal ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gap: 5,
    gridTemplateColumns: 'unset',
  },
  width: '100%',
}));

export const TwoColumn6Grid = styled(Grid)(({ theme }) => ({
  display: 'grid',
  columnGap: 15,

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 100%)',
    width: '100%',
  },
}));

export const TwoColumn = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: 20,
  gridTemplateColumns: 'repeat(2, 1fr)',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('xs')]: {
    gap: 5,
    gridTemplateColumns: 'unset',
  },
}));

export const AutocompleteGrid = styled(Grid)({
  textAlign: 'right',
  position: 'relative',
  '& .MuiTypography-root': {
    cursor: 'pointer',
    position: 'absolute',
    color: '#212121',
    top: '-25px',
    right: '0',
  },
});

export const ChipContainer = styled('div')({
  margin: '10px 0 0',
  '& .MuiChip-root': {
    margin: '0 10px 5px 0',
    backgroundColor: '#151b24',
    borderRadius: 8,
    padding: 5,

    '& svg': {
      height: 18,
      marginLeft: 3,
    },
  },
});

export const SaveButton = styled(Button)({
  maxWidth: 320,
  height: 50,
  borderRadius: 8,
});

export const FlexContainer = styled('div')<Theme, { $gap?: number }>(({ $gap = 0, theme }) => ({
  marginTop: 20,
  display: 'flex',
  alignItems: 'center',
  gap: $gap,
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const OpportunitiesCont = styled('div')(({ theme }) => ({
  marginBottom: 20,
  display: 'flex',
  flexDirection: 'column',
}));

export const InstructionCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#0B1017' : '#edf1f6',
  padding: '10px 20px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 8,
  border: '1px dashed #1D222A',
  margin: '26px 0',
  maxWidth: 865,
  wordBreak: 'break-word',
}));

export const DoBContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 10,

  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    textInputStyle: {
      backgroundColor: (theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE) + ' !important',
    },
    select: {
      backgroundColor: (theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE) + ' !important',
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK) + '!important', // Change this to your desired color,
        top: 15,
        right: 12,
      },
    },
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
    },
    UnionInput: {
      '& .MuiInputBase-input': {
        backgroundColor: (theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE) + ' !important',
      },
    },
    InputLabelText: {
      color: (theme.palette.type === 'dark' ? 'red' : 'yellow') + '!important',
    },
  }),
);
